<template>
	<div>
		<div class="btn-toolbar pull-right visible-lg visible-md visible-sm" role="toolbar">
			<div class="btn-group" role="group" aria-label="...">
				<input @keyup="keyUpdoFilter($event)" v-model="filter.text" type="text" class="form-control" placeholder="Buscar...">
			</div>

			<div class="btn-group" role="group" aria-label="...">
				<button
					title="Filtrar"
					ref="btnfilter"
					@click="doFilter()"
					data-style="slide-left"
					class="btn btn-default">
					<i class="fa fa-search" aria-hidden="true"></i>
				</button>
				<button
					title="Restablecer"
					ref="btnreset"
					@click="reset()"
					data-style="slide-left"
					class="btn btn-default">
					<i class="fa fa-refresh" aria-hidden="true"></i>
				</button>
			</div>
		</div>
		<div class="visble-xs hidden-lg hidden-md hidden-sm">
			<div id="filter" ref="filter" class="collapse">
				<div class="row">
					<div class="col-md-12  m-b-5">
						<div class="input-group">
							<input @keyup="keyUpdoFilter($event)" v-model="filter.text" type="text" class="form-control" placeholder="Buscar...">
							<span class="input-group-btn">
								<button
									title="Filtrar"
									ref="btnfilter"
									@click="doFilter()"
									data-style="slide-left"
									class="btn btn-default">
									<i class="fa fa-search" aria-hidden="true"></i>
								</button>
								<button
									title="Restablecer"
									ref="btnreset"
									@click="reset()"
									data-style="slide-left"
									class="btn btn-default">
									<i class="fa fa-refresh" aria-hidden="true"></i>
								</button>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				filter: {
					text: null,
					unavalible: false,
				},
			}
		},
		methods: {
			collapse() {
				$(this.$refs.filter).collapse("toggle")
			},
			keyUpdoFilter(event) {
				if(this.filter.text) {
					if(event.code == 13) {
						this.doFilter()
					} else {
						if(event.code != 32) {
							this.doFilter()
						}
					}
				} else {
					this.doFilter()
				}
			},
			doFilter() {
				if(this.filter.text) {
					this.filter.text = this.filter.text.trimStart()
				}
				this.$events.fire('filterSet', this.filter)
			},
			clearData() {
				this.filter.text = null
				this.filter.unavalible = false
			},
			reset() {
				this.clearData()
				this.$events.fire('filterReset', this.filter)
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/providers/views/FilterBar.vue